import HyperLink from 'component/commonComponents/hyperLink/hyperLink';
import React from 'react';
import { StyledAppCard, StyledTitle } from './icAppCard.style';

interface appItem {
  title: string;
  url: string;
  key: string;
}

export interface appCardProps {
  appItem: appItem;
  onViewMoreClick?: () => void;
  locale?: any;
}

const IcAppCard = (props: appCardProps) => {
  const { appItem, onViewMoreClick, locale } = props;
  const { title } = appItem;

  return (
    <StyledAppCard>
      <StyledTitle variant="h5" color="text.primary">{title}</StyledTitle>

      <HyperLink label={locale?.viewDetails} align="right" onClick={onViewMoreClick} />
    </StyledAppCard>
  );
};

export default IcAppCard;
